import { render } from "./Tag.vue?vue&type=template&id=bb7ceecc&scoped=true"
import script from "./Tag.vue?vue&type=script&lang=js"
export * from "./Tag.vue?vue&type=script&lang=js"

import "./Tag.vue?vue&type=style&index=0&id=bb7ceecc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb7ceecc"],['__file',"src/components/Tag.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bb7ceecc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bb7ceecc', __exports__)) {
    api.reload('bb7ceecc', __exports__)
  }
  
  module.hot.accept("./Tag.vue?vue&type=template&id=bb7ceecc&scoped=true", () => {
    api.rerender('bb7ceecc', render)
  })

}


export default __exports__